import React from 'react';

/**
 * What the report's conventions mean: which version each figure comes from, how
 * negative figures and missing lines are marked, and what the comparison is
 * matched on. Shown under every report level, with the comparison sentences
 * dropped when no comparison version is selected.
 *
 * Parentheses mark a NEGATIVE figure, not an unfavourable one — favourable vs
 * adverse is carried by colour (helpers/varianceColour.js), which inverts for
 * revenue. The legend used to claim otherwise and contradicted the output.
 */
const ActualVsBudgetReportLegend = ({ versionName, comparisonName }) => (
    <div className="tw-mt-2.5 tw-space-y-1 tw-text-[11.5px] tw-leading-[1.5] tw-text-charcoal-50">
        <p>
            {!!versionName && (
                <>
                    <b className="tw-font-semibold tw-text-charcoal-75">{$t('LE')}</b>
                    {` = ${versionName} (${$t('report version')})`}
                </>
            )}
            {!!comparisonName && (
                <>
                    {' · '}
                    <span className="tw-inline-block tw-h-2.5 tw-w-2.5 tw-rounded-sm tw-border tw-border-blue-25 tw-bg-blue-10 tw-align-middle tw-me-1" />
                    <b className="tw-font-semibold tw-text-charcoal-75">{$t('AB')}</b>
                    {` = ${comparisonName} (${$t('comparison version')}). `}
                    {$t('Month and reporting period compare actuals to the report version; the comparison version applies at lifetime level only.')}
                </>
            )}
        </p>
        <p>
            {$t('Figures in parentheses are negative; variance colour shows whether a figure is favourable or adverse.')}{' '}
            {!!comparisonName && $t('"—" means no equivalent line exists in that version (distinct from a budgeted nil).')}{' '}
            {!!comparisonName && (
                <>
                    {$t('Rows are matched on department, cost centre and budget line')} <b className="tw-font-semibold tw-text-charcoal-75">{$t('code')}</b>
                    {`, ${$t('not name.')} `}
                </>
            )}
            {$t('Commitments, risks, opportunities and forecast are lifetime values.')}{' '}
            {!!comparisonName && $t("Comparison figures are that version's budget before mark-up allocations.")}
        </p>
    </div>
);

export default ActualVsBudgetReportLegend;
